import { all } from 'redux-saga/effects'
import { Sagas as AppSaga } from 'modules/App/store/saga'
import AuthSaga from 'modules/Auth/store/saga'
import NotificationsSaga from 'modules/Notifications/store/saga'
import OnboardingSaga from 'modules/Onboarding/store/saga'

export const staticSagas = [AuthSaga, AppSaga, NotificationsSaga, OnboardingSaga]

export function* rootStaticSaga() {
  yield all(staticSagas.map((saga) => saga()))
}
